/**
 * @desc 根据id删除角色
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type DeleteRoleParameter = {
  id?: string
}

const method = 'DELETE'
const url = '/auth/role'

export const deleteRoleApi = (
  params?: DeleteRoleParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

deleteRoleApi.method = method
deleteRoleApi.url = url
